import { useIsAuthenticated } from "@azure/msal-react";
import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect, useContext } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";

const ProtectedRoute = (props) => {
  const isAuthenticated = useIsAuthenticated();
  const [authState, setAuthState] = useState(false);
  const [directToVessel, setDirectToVessel] = useState(false);
  const { instance, accounts, inProgress } = useMsal();
  const location = useLocation(); // Get the current route

  useEffect(() => {
    setAuthState(isAuthenticated);
  }, [isAuthenticated]);

  useEffect(() => {}, [instance, accounts, inProgress]);
  const Component = props.component;

  const handleLoginRedirect = () => {
    localStorage.setItem(
      "redirectUrl",
      location.pathname + location.search + location.hash
    );
  };

  return (
    <div>
      {authState || localStorage.getItem("offline_user") || directToVessel ? (
        <Component />
      ) : (
        <div className="unauthorized">
          {inProgress == "logout" ? (
            <p>Logging out...</p>
          ) : (
            <>
              <p>You are not authenticated. Please proceed Login</p>
              <Link to="/" className="link" onClick={handleLoginRedirect}>
                Go To Login
              </Link>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ProtectedRoute;
